import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

import React, { useState, useEffect } from 'react';

function App() {
  const [inputValue, setInputValue] = useState('');
  const [copySuccess, setCopySuccess] = useState('');

  const handleInputChange = (event) => {
    const inputText = event.target.value;
    setInputValue(processText(inputText));
  };

  // focus on the input textarea when the page is loaded
  useEffect(() => {
    document.getElementById("inputTextarea").focus();
  }, []);

  // copy to clipboard
  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      try {
        await navigator.clipboard.writeText(text);
        console.log('copied');
        setCopySuccess('コピーしました Copied to the clipboard');
        setTimeout(() => setCopySuccess(''), 5000);
        return true;
      } catch (error) {
        console.error('Copying to clipboard failed:', error);
        return false;
      }
    } else {
      let textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        var successful = document.execCommand('copy');
        console.log('copied');
        return successful;
      } catch (err) {
        console.error('Fallback: Copying text command was unsuccessful', err);
        return false;
      } finally {
        document.body.removeChild(textArea);
      }
    }
  }



  const [result, setResult] = useState({
    dept: {
      name: "",
      address: "",
      time: "",
      station: ""
    },
    dest: {
      name: "",
      address: "",
      time: "",
      station: ""
    },
    cost: 0,
  });

  function fullToHalf(str) {
    return str.replace(/[！-～]/g, function (s) {
      return s === '（' || s === '）' ? s : String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
  }

  function processText(text) {
    const result = {
      dept: {
        name: "",
        address: "",
        time: "",
        station: ""
      },
      dest: {
        name: "",
        address: "",
        time: "",
        station: ""
      },
      cost: 0,
    };

    // check language: if there's "出発地" then JP, if there's "已保存" then CN
    let lang;

    text = fullToHalf(text);

    if (text.indexOf("出発地") !== -1) {
      lang = "JP";
    } else if (text.indexOf("图层") !== -1) {
      lang = "CN";
    }

    console.log("Detected language:", lang);

    // remove purchasable ticket card block and override cost if needed
    if (lang === "JP") {
      const ticketCardRegex = /切符を購入する[\s\S]*?([\d,]+)円\s*(?:より|起)[\s\S]*?(?=\n\d{1,2}:\d{2}|\n|\nカレンダーに追加|$)/;
      const ticketCardMatch = text.match(ticketCardRegex);

      if (ticketCardMatch) {
        result.cost = parseInt(ticketCardMatch[1].replace(/,/g, ""));
        text = text.replace(ticketCardRegex, "\n");
      }
    } else if (lang === "CN") {
      const ticketCardRegex = /购票[\s\S]*?JP¥\s*([\d,]+)\s*起[\s\S]*?(?=\n\d{1,2}:\d{2}|\n添加到日历|$)/;
      const ticketCardMatch = text.match(ticketCardRegex);

      if (ticketCardMatch) {
        result.cost = parseInt(ticketCardMatch[1].replace(/,/g, ""));
        text = text.replace(ticketCardRegex, "\n");
      }
    }



    let departureMatch;
    if (lang === "JP") {
      departureMatch = text.match(/出発地: ([^、\,\n]+)([^\n]+)/);
    } else if (lang === "CN") {
      departureMatch = text.match(/从([^, ]*)/);
    }
    if (departureMatch) {
      result.dept.name = departureMatch[1];
    }

    let destinationMatch;

    if (lang === "JP") {
      destinationMatch = text.match(/目的地: ([^、\,\n]+)([^\n]+)/);
    }
    else if (lang === "CN") {
      destinationMatch = text.match(/到([^, ]*)/);
    }

    if (destinationMatch) {
      result.dest.name = destinationMatch[1];
    }

    let costMatch;
    if (lang === "JP") {
      costMatch = text.match(/料金: ([\d,]+)円/);
    }
    else if (lang === "CN") {
      costMatch = text.match(/费用：JP¥([\d,]+)/);
    }
    if (costMatch && result.cost === 0) {
      result.cost = parseInt(costMatch[1].replace(/,/g, ""));
    }


    let newText = text;

    // find the first real route time block, e.g. "\n13:20\n東京駅"
    const routeStartMatch = text.match(/\n(\d{1,2}:\d{2})\s*\n[^\n]+\n/);

    if (routeStartMatch) {
      const routeStartIndex = routeStartMatch.index + 1; // skip leading \n
      newText = text.substring(routeStartIndex);
    }

    let ticketInfoIndex;
    if (lang === "JP") {
      ticketInfoIndex = newText.indexOf("切符などの情報");
    } else if (lang === "CN") {
      ticketInfoIndex = newText.indexOf("票务信息");
    }

    if (ticketInfoIndex !== -1) {
      newText = newText.substring(0, ticketInfoIndex).trim();
    }
    // delete lines starting with "徒歩"
    newText = newText.replace(/^(徒歩.*)$/gm, "徒歩徒歩");
    newText = newText.replace(/^(步行.*)$/gm, "步行步行");

    // delete empty lines
    newText = newText.replace(/^[\s	]*$/gm, "");
    newText = newText.replace(/^\s*$/gm, "");
    newText = newText.replace(/\t/g, "");
    newText = newText.replace(/^\s*[\r\n]/gm, "");


    // delete the first three lines
    newText = newText.replace(/^.+\n.+\n.+\n/, "");
    // delete the last four line if there's cost info
    if (result.cost > 0) {
      newText = newText.replace(/\n.+\n.+\n.+\n.+$/, "");
    } else {
      newText = newText.replace(/\n.+\n.+\n.+$/, "");
    }
    // process same stop transfer
    newText = newText.replace(/(^|\n)(\d{1,2}:\d{2})\n(.+)$\n\d{1,2}:\d{2}/gm, "$1$2\n$3");


    //format
    const lines = newText.trim().split('\n');
    const formattedLines = [];

    const timeRegex = /^\d{1,2}:\d{2}$/;
    const twoTimeRegex = /^(\d{2}:\d{2})(\d{2}:\d{2})$/;

    console.log(newText);

    let platformRegex;
    if (lang === "JP") {
      platformRegex = /([\d+\/]*)\s*番ホーム/;
    } else if (lang === "CN") {
      platformRegex = /第\s*([\d+/]+)\s*站台/;
    }
    for (let i = 0; i < lines.length; i++) {
      // real time: HH:MMHH:MM in one line to HH:MM (only take the second time)
      if (lines[i].match(twoTimeRegex)) {
        lines[i] = lines[i].replace(twoTimeRegex, "$2");
      }
      if (timeRegex.test(lines[i])) {
        // update the start and end time
        if (!result.dept.time) {
          result.dept.time = lines[i];
        }
        result.dest.time = lines[i];
        const departure = lines[i + 1] ? lines[i + 1] : '';
        const isTimeFormat = /^\d{1,2}:\d{2}$/.test(lines[i + 2]);
        let mode = isTimeFormat ? '' : (lines[i + 2] ? lines[i + 2] : '');
        if (lang === "JP") {
          mode = mode.replace(/(.*線)/g, "$1 ").replace(/^(.*ライン)/g, "$1 ").replace(/(.*号)/g, "$1 ").replace(/^(電車)/, "").replace(/^(地下鉄)/, "").replace(/^(路面電車)/, "").replace(/^(新幹線)/, "").replace(/徒歩徒歩/g, "").replace(/^(バス)/, "バス：").replace(/^(フェリー)/, "フェリー：").replace(/(.*サンライズ..)/g, "$1 ");
          mode = mode.replace(/(通勤快急|通勤急行|区間特急|快速急行|空港急行|直通特急|通勤特急|新快速|特快速|準特急|特急線|快特|寝台|各停|急行|普通|快速|特急)/g, "$1 ");
        } else if (lang === "CN") {
          mode = mode.replace(/(.*线)/g, "$1 ").replace(/(.*Line)/g, "$1 ").replace(/(.*線)/g, "$1 ").replace(/^(地铁)/, "").replace(/^(路面电车)/, "").replace(/(.*号)/g, "$1 ").replace(/^(火车)/, "").replace(/^(新干线)/, "").replace(/步行步行/g, "").replace(/^(公交)/, "公交：").replace(/^(轮渡)/, "轮渡：").replace(/(.*日出..)/g, "$1 ");
          mode = mode.replace(/(通勤快急|通勤急行|区間特急|快速急行|空港急行|直通特急|通勤特急|新快速|特快速|准特急|特急线|各站停车|卧铺|各停|快特|普通|急行|快速|特急)/g, "$1 ");
        }

        // check duplicated special rapid train names
        for (let i = 1; i <= 10; i++) {
          if (mode.slice(0, i) === mode.slice(i, 2 * i)) {
            mode = mode.slice(i);
            break;
          }
        }

        // check specific pattern for shinkansen
        mode = mode.replace(/(新幹線|新干線)\s+(\S+\d+号)\s+(\S+)/g, (match, p1, p2, p3) => {
          const p2Prefix = p2.replace(/\d+号$/, ''); // Remove trailing digits and "号" from p2
          const p3Prefix = p3.slice(0, p2Prefix.length); // Compare the prefix of p3 with cleaned p2
          const p3Remaining = p3.slice(p2Prefix.length); // Keep the remaining part of p3
          return p2Prefix === p3Prefix ? `${p1} ${p2} ${p3Remaining}`.trim() : match;
        });


        // check platform for the i+5 line
        if (platformRegex.test(lines[i + 5])) {
          mode = `${mode} ${lines[i + 5].match(platformRegex)[1]}番線`;
        }

        // check direct train
        if (lang === "JP") {
          if (lines[i + 6] && lines[i + 6].indexOf("直通") !== -1) {
            mode = `${mode} 直通`;
          }
        } else if (lang === "CN") {
          if (lines[i + 6] && lines[i + 6].indexOf("继续乘坐同一辆车") !== -1) {
            mode = `${mode} 直通`;
          }
        }
        formattedLines.push(`→${lines[i]}【${departure}】${mode}`);
        // update the start and end station
        if (!result.dept.station) {
          result.dept.station = departure;
        }
        result.dest.station = departure;
      }
    }
    // // remove the last line
    // formattedLines.pop();

    // clean the whole lines which contains `【】`
    let cleanLines = formattedLines.filter(line => line.indexOf('【】') === -1);

    // clean all lines with 【time】 in some case of delays
    cleanLines = cleanLines.filter(line => !/【\d{1,2}:\d{2}】/.test(line));

    const formattedText = cleanLines.join('\n');

    setResult(result);

    // copy to clipboard when it's not empty
    if (formattedText) {
      if (copyTextToClipboard(formattedText)) {
        console.log("auto copied");
      } else {
        console.log("failed");
      }
    }

    return formattedText;

  }

  // function to remove time stamps from the text
  function onClearTime() {
    const text = inputValue;
    const cleanedText = text.replace(/\d{1,2}:\d{2}/g, "");
    setInputValue(cleanedText);
    // give feedback
    setCopySuccess('時刻を削除しました Removed time stamps');
    setTimeout(() => setCopySuccess(''), 5000);
  }

  useEffect(() => {
    // monitor messages from the parent window
    const handleMessage = (event) => {
      // check the origin of the message
      // if origin contains google 
      if (event.origin.includes("google")) {
        const message = event.data; // 获取消息内容
        if (typeof message === "string") {
          console.log("Received message:", message);
          setInputValue(processText(message));
          setTimeout(() => setCopySuccess(''), 5000);
        }
      } else {
        console.warn("Unauthorized message origin:", event.origin);
      }
    };

    // add event listener
    window.addEventListener("message", handleMessage);

    // remove event listener
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);




  return (
    <div className="App">
      <div className="container">
        <header class="d-flex flex-wrap justify-content-between align-items-center py-3 border-bottom">
          <a href="." class="d-flex align-items-center text-dark text-decoration-none">
            <span class="fs-4">Route2TXT：より見やすい経路 More Readable Routes</span>
          </a>
          <div class="ms-auto">
            {copySuccess && <span class="copy-success">{copySuccess}</span>}
          </div>
        </header>


        {/* warning bar */}
        <div className='row mt-2'>
          <div className='col-md-12'>
            <div className="alert alert-warning" role="alert">
              本サイトは、日本語と中国語のみをサポートしています。This site only supports Japanese and Chinese inputs.
            </div>
            <div className="alert alert-primary" role="alert">
              <code>Ctrl+A</code>を使用して、Googleマップの公共交通機関の経路ページの全内容をコピーし、「入力」ボックスに貼り付けてください。<br />
              Use <code>Ctrl+A</code> to copy all content from the Google Maps public transit route page, and paste it into the "入力" box.

            </div>
          </div>
        </div>
        <div className='row mt-2 mb-2'>
          <div className='col-md-4 mb-2'>
            <label for="inputTextarea" className='form-label'><i class="bi bi-clipboard2-fill"></i> 入力</label>
            <textarea class="form-control textarea-no-scroll" id="inputTextarea" rows="15" onChange={handleInputChange} placeholder="ここにペースト　Paste here"></textarea>
          </div>
          <div className='col-md-3 mb-2'>
            <div className='row'>
              <form>
                <div className="mb-3">
                  <label htmlFor="deptName" className="form-label">
                    <i class="bi bi-geo-alt-fill"></i> 出発地
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="deptName"
                    name="deptName"
                    value={result.dept.name}
                    disabled={result.dept.name === ""}
                    onClick={copyTextToClipboard.bind(this, result.dept.name)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="destName" className="form-label">
                    <i class="bi bi-flag-fill"></i> 目的地
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="destName"
                    name="destName"
                    value={result.dest.name}
                    disabled={result.dest.name === ""}
                    onClick={copyTextToClipboard.bind(this, result.dest.name)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="cost" className="form-label">
                    <i class="bi bi-arrow-left-right"></i> ルート
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="route"
                    name="route"
                    value={result.dept.name + '-' + result.dest.name}
                    disabled={result.dept.name === "" && result.dest.name === ""}
                    onClick={copyTextToClipboard.bind(this, result.dept.name + '-' + result.dest.name)}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="cost" className="form-label">
                    <i class="bi bi-currency-yen"></i> 料金
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="cost"
                    name="cost"
                    value={result.cost}
                    disabled={result.cost === 0}
                    onClick={copyTextToClipboard.bind(this, result.cost)}
                  />
                </div>
              </form>
            </div>
            <div className='row mt-2 mb-2'>
              <div className='col-md-12'>
                {/* clear time */}
                <button
                  className="btn btn-warning"
                  onClick={() => onClearTime()}
                  disabled={inputValue === ""}
                >
                  <i className="bi bi-clock-history"></i> 時刻抜き Remove Time
                </button>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12 mt-2 mb-2'>
                {/* clear time */}
                <button
                  className="btn btn-primary"
                  onClick={() => copyTextToClipboard(result.dept.time + "-" + result.dest.time + "\t" + result.dept.station + '-' + result.dest.station + "\t\"" + inputValue + "\"\t\t" + result.cost)}
                  disabled={inputValue === ""}
                >
                  <i className="bi bi-table"></i> 表でコピー Copy as Table
                </button>
              </div>
            </div>
          </div>
          <div className='col-md-5 mb-2'>
            <label for="outputTextarea" className='form-label'><i class="bi bi-sign-turn-right-fill"></i> 経路</label>
            <textarea
              class="form-control textarea-no-scroll"
              id="outputTextarea"
              rows="15"
              value={inputValue}
              onClick={copyTextToClipboard.bind(this, inputValue)}
              disabled={inputValue === ""}>
            </textarea>
          </div>
        </div>
        <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
          <div class="col-9 d-flex align-items-center">
            <span class="mb-md-0 text-muted">
              ©
              <a href="https://github.com/ihkk" class="link text-muted" target="_blank" style={{ textDecoration: "none" }}>Jacky HE</a>            </span>
          </div>

          <ul class="nav col-3 justify-content-end list-unstyled d-flex">


            <li class="ms-3">
              <a className="text-muted" target="_blank" href="https://www.tampermonkey.net/script_installation.php#url=https://update.greasyfork.org/scripts/520891/R2T%20Add-on.user.js">
                <i class="bi bi-plugin"></i>
              </a>
            </li>

            <li class="ms-1">
              <a className="text-muted" target="_blank" href="https://creativecommons.org/licenses/by-nc-sa/4.0/deed.zh-hans">
                <i class="bi bi-cc-circle-fill"></i>
              </a>
            </li>

            <li class="ms-1">
              <a className="text-muted" target="_blank" href="https://github.com/ihkk/Route2TXT">
                <i class="bi bi-github"></i>
              </a>
            </li>

          </ul>
        </footer>
      </div>
    </div >
  );
}

export default App;
